import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, Tooltip } from "recharts";
import { getPlatformMeta } from "@/data/platforms";
import { t } from "@/lib/strings";

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-obsidian text-white px-3 py-2 font-data text-xs border-2 border-obsidian">
      <div className="uppercase tracking-widest text-neutral-400">{d.name}</div>
      <div className="text-base font-bold"><span dir="ltr">{d.mentions}</span> {t("results.mentions")} · <span dir="ltr">{d.share}%</span></div>
    </div>
  );
};

const YTick = ({ x, y, payload }) => {
  const meta = getPlatformMeta(payload.value);
  const Icon = meta.Icon;
  const label = payload.value.replace("Google AI Overviews", "Google AI").replace("Microsoft Copilot", "Copilot");
  return (
    <g transform={`translate(${x - 140},${y})`}>
      <foreignObject width="136" height="26" x="0" y="-13">
        <div style={{ display: "flex", alignItems: "center", gap: 6, height: 26 }}>
          <Icon style={{ fontSize: 15, color: meta.color, flexShrink: 0 }} />
          <span style={{ fontFamily: "JetBrains Mono", fontSize: 11, color: "#0A0A0A", whiteSpace: "nowrap" }}>{label}</span>
        </div>
      </foreignObject>
    </g>
  );
};

export const PlatformChart = ({ platforms = [] }) => {
  const data = [...platforms].sort((a, b) => b.mentions - a.mentions);
  const max = Math.max(...data.map((d) => d.mentions), 1);
  return (
    <div className="h-[280px] w-full" data-testid="platform-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 24, left: 12, bottom: 4 }} barCategoryGap={12}>
          <XAxis type="number" hide domain={[0, max]} />
          <YAxis type="category" dataKey="name" width={148} tickLine={false} axisLine={false} tick={<YTick />} interval={0} />
          <Tooltip cursor={{ fill: "rgba(10,10,10,0.04)" }} content={<CustomTooltip />} />
          <Bar dataKey="mentions" isAnimationActive radius={0} barSize={20}>
            {data.map((entry, i) => {
              const meta = getPlatformMeta(entry.name);
              return <Cell key={entry.name} fill={i === 0 ? "#FF4500" : meta.color} />;
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PlatformChart;
